/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiStyle from '@goldwasserexchange/oui-style';
import ouiDom from '@goldwasserexchange/oui-dom';
import * as React from 'react';
import { useAtomValue } from 'jotai';
import { useSanityLatestNewsById } from '../../../../../../../../../../../../../../../../../../../../../../sanity';
import { pathnameUrlLanguageAtom } from '../../../../../../../../../../../../../../../../../../../../../../history';

export const LatestNewsTitleContainer = (props: React.PropsWithChildren<{
  id: string,
}>) => {
  const {
    id,
    children,
  } = props;
  const {
    data,
  } = useSanityLatestNewsById(id);
  const locale = useAtomValue(pathnameUrlLanguageAtom);
  const css = ouiStyle.useACss({
    display: ouiStyle.Constants.DisplayProp.block,
    color: ouiStyle.Constants.Colors.accent,
    hoverColor: ouiStyle.Constants.Colors.logoBlue,
    fontWeight: ouiStyle.Constants.FontWeightProp.bold,
    paddingVertical: 'half',
  });
  return (
    <ouiDom.A.Link
      href={`/${locale}/news/${data?.slug}`}
      css={ouiStyle.mediaQuery(css)}
    >
      {children}
    </ouiDom.A.Link>
  );
};
